module.exports = __webpack_public_path__ + "static/img/3.fa9f883.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer5/en/btn2/3.jpg
// module id = 8hZO
// module chunks = 0